export interface BootstrapDataState {
  loading: boolean;
  loaded: boolean;
  error?: string;
  webApiVersion: string;
}

export const initialState: BootstrapDataState = {
  loading: false,
  loaded: false,
  error: undefined,
  webApiVersion: 'N/A'
};
